/**
 * content-widgets.js
 *
 * Import the JS for your content widgets here.
 *
 */
import './engagement-video/cw-engagement-video';
import './featurette/cw-featurette-d';
import './photo-gallery/cw-photo-gallery';



// WEBPACK FOOTER //
// ./src/content-widgets/content-widgets.js